import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--step-bar"
export default class extends Controller {
  static values = {
    formId: String,
  };

  connect() {
    // コントローラーが接続されました
  }

  navigate(e) {
    e.preventDefault();

    // form IDをvalueから取得
    const formId = this.formIdValue;

    if (!formId) {
      console.error("Form ID value is not set");
      return;
    }

    // 対応するステップナビゲーション用の隠しフォームを取得
    const stepForm = document.getElementById(formId);

    if (!stepForm) {
      console.error(`Form with ID '${formId}' not found`);
      return;
    }

    // メインフォーム（入力データがあるフォーム）を取得
    const mainForm = document.querySelector(
      'form[data-controller*="resumin--form-navigation"]'
    );

    if (mainForm) {
      // メインフォームのデータを隠しフォームに転送
      const form = new FormData(mainForm);

      // メインフォームのデータを隠しフォームに追加
      for (const [key, value] of form.entries()) {
        // authenticity_tokenは既にstepFormに設定されている値を利用するため、上書きしない
        if (key === "authenticity_token") continue;

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        stepForm.appendChild(input);
      }
    }

    // フォームを送信
    stepForm.requestSubmit();
  }
}
